export enum Searchmode {
  local,
  server,
}

export enum SearchType {
  none,
  dishLibrary,
  menu,
  addOns,
  variants,
  kitchenNotes,
  AddIngredients
}
